export default {
  "ui:order": ["name", "reasonType", "parentReason", "*", "displayName", "isActive"],
  isActive: {
    "ui:widget": "toggle",
    "ui:options": {
      labels: [
        { label: "Enabled", value: true },
        { label: "Disabled", value: false },
      ],
    },
  },
  nurseTransferEligibility: {
    "ui:widget": "hidden",
  },
};
